// استيراد دوال React لإدارة الحالات والتأثيرات الجانبية
import { useEffect, useState } from "react";
// استيراد مكونات Form, Button, Container, Card من React Bootstrap
import { Form, Button, Container, Card } from "react-bootstrap";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد رابط API الخاص بالمستخدم
import { USER } from "../../../API/Api";
// استيراد مكون التحميل
import Loading from "../../../components/Loading/Loding";
// استيراد دوال التنقل والحصول على المعاملات من React Router
import { useNavigate, useParams } from "react-router-dom";

// المكون الرئيسي لتعديل بيانات المستخدم
export default function User ()
{
    // حالة لتخزين بيانات النموذج (الاسم، البريد الإلكتروني، الدور)
    const [ formData, setFormData ] = useState( {
        name: '',
        email: '',
        role: '',
    } );
    // حالة لتعطيل زر الإرسال (تمكينه بعد تحميل البيانات)
    const [ disable, setDisable ] = useState( true );
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // دالة للتنقل بين الصفحات
    const nav = useNavigate();

    // استخراج معرف المستخدم من معاملات الرابط
    const { id } = useParams();

    // تأثير جانبي لجلب بيانات المستخدم عند تحميل المكون
    useEffect( () =>
    {
        // تفعيل حالة التحميل
        setLoading( true );
        // إرسال طلب GET لجلب بيانات المستخدم باستخدام المعرف
        Axios.get( `${ USER }/${ id }` )
            .then( ( response ) =>
            {
                // إلغاء حالة التحميل
                setLoading( false );
                // تعبئة بيانات النموذج بالبيانات المسترجعة
                setFormData( {
                    name: response.data.name,
                    email: response.data.email,
                    role: response.data.role,
                } );
                // تمكين زر الإرسال بعد تحميل البيانات
                setDisable( false );
            } )
            .catch( () =>
            {
                // في حالة الخطأ، التوجيه إلى صفحة 404
                nav( "/dashboard/users/page/404", { replace: true } );
            } );
    }, [ id ] ); // إعادة التشغيل عند تغيير المعرف

    // دالة غير متزامنة لمعالجة تقديم النموذج (تحديث بيانات المستخدم)
    async function handleSubmit ( e )
    {
        // منع إعادة تحميل الصفحة
        e.preventDefault();
        // تفعيل حالة التحميل
        setLoading( true );
        try
        {
            // إرسال طلب POST لتحديث بيانات المستخدم
            await Axios.post( `${ USER }/edit/${ id }`, {
                name: formData.name,
                email: formData.email,
                role: formData.role,
            } );
            // إعادة توجيه المستخدم إلى صفحة قائمة المستخدمين بعد النجاح
            window.location.pathname = "/dashboard/users";
        } catch ( error )
        {
            // إلغاء حالة التحميل في حالة الخطأ
            setLoading( false );
            // طباعة الخطأ في وحدة التحكم
            console.error( error );
        }
    }

    // دالة معالجة تغيير المدخلات
    const handleChange = ( e ) =>
    {
        // استخراج اسم الحقل والقيمة من الحدث
        const { name, value } = e.target;
        // تحديث بيانات النموذج مع الاحتفاظ بالبيانات السابقة
        setFormData( {
            ...formData,
            [ name ]: value
        } );
    };

    // عرض واجهة تعديل المستخدم
    return (
        <>
            {/* عرض مكون التحميل إذا كانت الحالة true */ }
            { loading && <Loading /> }
            {/* حاوية مركزية في منتصف الشاشة */ }
            <Container className="d-flex justify-content-center align-items-center vh-100">
                {/* بطاقة تحرير المستخدم */ }
                <Card className="bg-light p-4 rounded shadow" style={ { width: '80%' } }>
                    {/* عنوان البطاقة */ }
                    <Card.Title className="text-center mb-4 text-primary">Edit User</Card.Title>
                    {/* نموذج التحرير */ }
                    <Form onSubmit={ handleSubmit } className="bg-white p-3 rounded">
                        {/* حقل الاسم */ }
                        <Form.Group controlId="formName">
                            <Form.Label>Name:</Form.Label> {/* تسمية الحقل */ }
                            <Form.Control
                                value={ formData.name } // قيمة الحقل
                                onChange={ handleChange } // دالة التغيير
                                name='name' // اسم الحقل
                                type="text" // نوع الإدخال نص
                                placeholder="Enter your Name" // النص الافتراضي
                                required // الحقل مطلوب
                                className="border-primary" // كلاس للحدود
                            />
                        </Form.Group>

                        {/* حقل البريد الإلكتروني */ }
                        <Form.Group controlId="formEmail">
                            <Form.Label>Email:</Form.Label> {/* تسمية الحقل */ }
                            <Form.Control
                                value={ formData.email } // قيمة الحقل
                                onChange={ handleChange } // دالة التغيير
                                name='email' // اسم الحقل
                                type="email" // نوع الإدخال بريد إلكتروني
                                placeholder="Enter your email" // النص الافتراضي
                                required // الحقل مطلوب
                                className="border-primary" // كلاس للحدود
                            />
                        </Form.Group>

                        {/* حقل الدور (قائمة منسدلة) */ }
                        <Form.Group controlId="formRole">
                            <Form.Label>Role:</Form.Label> {/* تسمية الحقل */ }
                            <Form.Select
                                value={ formData.role } // القيمة المحددة
                                onChange={ handleChange } // دالة التغيير
                                name="role" // اسم الحقل
                                required // الحقل مطلوب
                                className="border-primary" // كلاس للحدود
                            >
                                <option disabled value="">Select role</option> {/* الخيار الافتراضي */ }
                                <option value="1995">Admin</option> {/* خيار المدير */ }
                                <option value="2001">User</option> {/* خيار المستخدم */ }
                                <option value="1996">Writer</option> {/* خيار الكاتب */ }
                            </Form.Select>
                        </Form.Group>

                        {/* زر الإرسال */ }
                        <Button
                            disabled={ disable } // تعطيل الزر حتى تحميل البيانات
                            className="btn btn-primary mt-3 w-100" // كلاس الزر
                            type="submit" // نوع الزر إرسال
                        >
                            Submit {/* نص الزر */ }
                        </Button>
                    </Form>
                </Card>
            </Container>
        </>
    );
}